/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Duplicate_To_Other_DaysInputs */



/**
* | output |
* | --- |
* | "Duplicate to other days" |
*
* @param {Duplicate_To_Other_DaysInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const duplicate_to_other_days = /** @type {((inputs?: Duplicate_To_Other_DaysInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplicate_To_Other_DaysInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Duplicate to other days")
	return /** @type {LocalizedString} */ ("Dupliquer vers d'autres jours")
});